export default {"src":"/_next/static/media/mrkl.b4359e4d.svg","height":2335,"width":1035,"blurWidth":0,"blurHeight":0};